<template>
<div class="container">

    <div v-if="is_ampiezza && !dadosRemarcacao && ( !buscando || data || horarios )">

        <historico-marcacoes 
            :portal="true"
            :historico="historicoMarcacoes" 
            @refresh="load_mine()" 
            :poderevisar="false"
            :naoremarcar="dados && dados.paciente && dados.paciente.paciente_unidade ? false : true"
            :blockproc="true"
            :blockcancelar="true"
            @remarcar="remarcar"
            v-if="minhas && historicoMarcacoes && historicoMarcacoes.length > 0" />

    </div>

    <template v-else>

        <div class="mb-3" v-if="$store.state.user.st_tipo != 'X' && !nao_marcar_por_outro && !is_ampiezza">
            <az-input
                type="button-group"
                :optionsList="[
                    { id: 'M', search: 'Agendar para Mim' }, 
                    { id: 'P', search: 'Agendar para Outra Pessoa' }
                ]"
                :edicao="!horarios"
                v-model="agendar_para"
                @input="alterar_agendar_para" />
        </div>

        <div class="mb-3" v-if="1==0 && minhas && historicoMarcacoes && historicoMarcacoes.length > 0">

            <p class="alert alert-primary lead">Agendas Marcadas</p>

            <historico-marcacoes 
                :portal="true"
                :historico="historicoMarcacoes" 
                @refresh="load_mine()" 
                :poderevisar="true"
                :naoremarcar="true"
                v-if="minhas && historicoMarcacoes && historicoMarcacoes.length > 0" />

        </div>

        <template v-if="!minhas">

            <az-loading msg="Aguarde..." />

            <div class="spinner-border mb-3" 
                style="width: 3rem; height: 3rem;"
                role="status" v-if="false">
                <span class="sr-only">Loading...</span>
            </div>

        </template>

        <template v-if="minhas">

            <p class="alert alert-warning d-flex justify-content-between" v-if="remarcacao && dadosRemarcacao">
                <span>
                    <span class="text-muted mr-1">
                        <i class="fas fa-retweet mr-1"></i>
                        Remarcação de 
                    </span>
                    <span>
                        {{ getHumanDate (dadosRemarcacao.dt_inicio) }}, {{ getHumanDay (dadosRemarcacao.dt_inicio) }}, às 
                        {{ dadosRemarcacao.dt_inicio.substr(11,5) }}
                    </span>
                </span>
                <span class="ml-3 text-muted">
                    {{ dadosRemarcacao.procedimento.search }}
                </span>
            </p>

            <div class="row">
                <div class="col col-12">
                    <p class="alert alert-primary" v-if="mensagem" v-html="mensagem"></p>
                    <p class="alert alert-primary lead" v-else>
                        Agende seu atendimento
                    </p>
                </div>
            </div>

            <div class="row justify-content-center" v-if="!horarios">
                <div class="col col-12 col-md-12 col-lg-8">

                    <!-- Start da Marcação -->

                    <div class="row" v-if="data">
                        <div class="col col-12">
                            <p class="alert alert-primary text-center">
                                <i class="far fa-calendar-plus"></i>
                                {{ getHumanDate (data) }} | {{ getHumanDay (data) }} 
                                <strong v-if="hora">
                                    <i class="fas fa-clock ml-3"></i>
                                    {{ hora }}
                                </strong>
                            </p>
                        </div>
                    </div>

                    <div class="col my-3" v-if="aviso_final">
                        <div v-if="resumo && resumo.msg_final">
                            <div v-html="resumo.msg_final"></div>
                            <div class="mt-3">
                                <button type="button" class="btn btn-success" @click="aviso_final = null">Avançar</button>
                            </div>
                        </div>

                        <div class="display-4 text-center" v-else>
                            <div>
                                <i class="far fa-calendar-check fa-3x text-success mb-3"></i>
                            </div>
                            <div class="display-4">Marcação Realizada!</div>
                        </div>
                    </div>

                    <!-- Campos de Buscar -->

                    <div v-if="!aviso_final">

                        <div v-if="!buscando || data"> 

                            <!-- Seleção do Paciente-->

                            <div class="row d-flex justify-content-center mb-2" v-if="fluxo == 2">

                                <div class="col col-12">

                                    <az-input placeholder="Paciente"
                                            icon="fas fa-user"
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            service="pacientes.index"
                                            optionsDisplay="st_nome"
                                            ref="info_paciente"
                                            v-model="dados.paciente" 
                                            @onEnter="focusOn('info_plano')"
                                            @input="selecionarPaciente()"/>

                                </div>

                            </div>

                            <!-- Seleção da Unidade -->

                            <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo && agendar_para == 'P'">

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Data de Nascimento"
                                        type="date"
                                        :compact="true"
                                        v-model="dados.dt_nascimento" />
                                </div>

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'M', search: 'Masculino' },
                                            { id: 'F', search: 'Feminino' },
                                        ]"
                                        optionsData="id"
                                        v-model="dados.ch_sexo" />
                                </div>

                            </div>

                            <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo && this.$store.state.unidade.unidade_operacaos.length > 1">

                                <div class="col col-12">

                                    <div class="input-group mb-1">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                                <i class="fa fa-building fa-fw" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                        <select class="form form-control" v-model="dados.unidade_operacao">
                                            <option value="">Todas as Unidades</option>
                                            <option v-for="(und, iux) in this.$store.state.unidade.unidade_operacaos" :value="und" :key="iux">{{ und.search }}</option>
                                        </select>
                                    </div>
                                </div>

                            </div>

                            <!-- Seleção da Operadora -->

                            <template v-if="fluxo && ( fluxo == 1 || dados.paciente ) && ( !config_portal_unidade_obrig || dados.unidade_operacao )">

                                <template v-if="block_alterar_plano && dados.plano && dados.plano.search">

                                    <az-input
                                        class="mb-3"
                                        placeholder="Operadora..."
                                        icon="far fa-credit-card fa-fw"
                                        :edicao="false"
                                        v-model="dados.plano.search" />

                                </template>

                                <template v-if="!id_plano_padrao && ( !block_alterar_plano || !dados.paciente )">

                                    <div class="row d-flex justify-content-center mb-2">

                                        <div class="col col-12">

                                            <az-input
                                                type="button-group"
                                                :optionsList="[
                                                    { id: 'P', search: 'Particular' },
                                                    { id: 'O', search: 'Plano de Saúde' },
                                                ]"
                                                optionsData="id"
                                                v-model="dados.tipo_pagamento" 
                                                @input="selecionarTipoPagamento()" />

                                        </div>

                                    </div>

                                    <div class="row d-flex justify-content-center mb-2" v-if="dados.tipo_pagamento && dados.tipo_pagamento == 'O'">

                                        <div class="col col-12">

                                            <az-input
                                                placeholder="Selecione a Operadora..."
                                                icon="far fa-credit-card fa-fw"
                                                type="select" 
                                                optionsMode="json"
                                                service="operadoras.index"
                                                :optionsSync="false"
                                                optionsData="id_operadora"
                                                :optionsList="lista_operadoras_exibir"
                                                :optionsParm="{ agenda_online: true }"
                                                v-model="dados.plano.id_operadora"
                                                ref="info_plano"
                                                @onEnter2="focusOn('info_procedimento')" />

                                        </div>

                                    </div>

                                </template>

                                <template v-if="id_plano_padrao || ( dados.tipo_pagamento && dados.plano.id_operadora && lista_operadoras_exibir.find(item => item.id_operadora == dados.plano.id_operadora) )">

                                    <div class="row d-flex justify-content-center mb-2" v-if="!id_plano_padrao && ( !block_alterar_plano || !dados.paciente )">

                                        <div class="col col-12">

                                            <az-input
                                                placeholder="Selecione o Plano..."
                                                icon="fab fa-product-hunt fa-fw"
                                                type="select" 
                                                optionsMode="json"
                                                service="planos.index"
                                                :optionsSync="false"
                                                optionsData="id_plano"
                                                :optionsList="lista_planos_exibir"
                                                v-model="dados.plano.id_plano"
                                                ref="info_plano"
                                                @onEnter="focusOn('info_procedimento')" />

                                            <!-- lista_planos.filter(item => item.id_operadora == dados.plano.id_operadora)" -->

                                        </div>

                                    </div>

                                    <template v-if="id_plano_padrao || ( dados.plano.id_plano && lista_planos.find(item => item.id_operadora == dados.plano.id_operadora && item.id_plano == dados.plano.id_plano) )">

                                        <!-- Seleção CONSULTA / PROCEDIMENTO -->

                                        <div class="row d-flex justify-content-center mb-2" v-if="fluxo && ( id_plano_padrao || dados.plano.id_plano ) && !config_apenas_cons && !config_apenas_proced">

                                            <div class="col col-12">

                                                <az-input
                                                    type="button-group"
                                                    :optionsList="[{ id: 'C', search: 'Consulta' }, { id: 'P', search: 'Procedimento' }]"
                                                    v-model="dados.tipoProcedimento" 
                                                    @input="verificarTipoProcedimento ()" />

                                            </div>

                                        </div>

                                        <!-- Seleção do Procedimento -->

                                        <template v-if="fluxo && dados.plano && dados.plano.id_plano && dados.tipoProcedimento == 'C' && lista_especialidades && lista_especialidades.length">

                                            <div class="row d-flex justify-content-center mb-0">

                                                <div class="col col-12">
                                                    <az-input placeholder="Especialidade"
                                                        icon="fas fa-stethoscope fa-fw"
                                                        type="select" 
                                                        service="especialidades.index"
                                                        optionsMode="json"
                                                        optionsName="especialidades-agenda-online"
                                                        :optionsParms="{ agenda_online: true }"
                                                        :optionsList="lista_especialidades"
                                                        v-model="dados.especialidade"
                                                        @input="verificarTipoProcedimento()" />
                                                </div>

                                            </div>

                                            <div class="row mb-0 mt-2"  v-if="dados && dados.consultas && dados.consultas.length > 1">

                                                <div class="col col-12">
                                                    <az-input placeholder="Tipo de Consultas"
                                                        icon="fas fa-mouse-pointer fa-fw"
                                                        type="select" 
                                                        optionsMode="json"
                                                        :optionsList="dados.consultas"
                                                        v-model="dados.procedimento"
                                                        @input="selecionarProcedimento (dados.procedimento)" 
                                                        @onEnter="enterNoProcedimento ()" />
                                                </div>

                                            </div>

                                        </template>

                                        <template>

                                            <div class="row d-flex justify-content-center mb-2" v-show="fluxo && dados && dados.plano && dados.tipoProcedimento == 'P'">

                                                <div class="col col-12">

                                                    <az-input
                                                        v-show="fluxo && dados && dados.plano && dados.tipoProcedimento == 'P'"
                                                        placeholder="Procedimento" 
                                                        icon="fas fa-play"
                                                        :type="is_proc_lista ? 'select' : 'autocomplete'"
                                                        optionsMode="aql"

                                                        optionsName2="procedimentos.agenda" 
                                                        :optionsParm2="{ agenda_on_line: true }"

                                                        :optionsName=" 'procedimentos.agenda' 
                                                            + ( dados.unidade_operacao ? '.uo' + dados.unidade_operacao.id_unidade_operacao : '' )"
                                                        :optionsParm="{
                                                                agenda_on_line: true, 
                                                                id_unidade_operacao: dados.unidade_operacao ? dados.unidade_operacao.id_unidade_operacao : null, 
                                                            }"

                                                        :optionsSync="false"
                                                        v-model="dados.procedimento"
                                                        ref="info_procedimento"
                                                        @input="selecionarProcedimento (dados.procedimento)" 
                                                        @onEnter="enterNoProcedimento ()" /> 

                                                </div>

                                            </div>

                                        </template>

                                        <!-- Selecionar Médico -->

                                        <div class="row d-flex justify-content-center mb-3" v-if="fluxo 
                                            && !config_block_sel_medico
                                            && ( listaMedicos )
                                            && ( dados.procedimento )
                                            && ( 
                                                ( dados.tipoProcedimento == 'C' && dados.especialidade && dados.procedimento ) ||
                                                ( dados.tipoProcedimento == 'P' && dados.procedimento ) 
                                            )">

                                            <div class="col col-12" v-if="listaMedicos && listaMedicos.length">

                                                <az-input placeholder="Qualquer Profissional"
                                                    icon="fas fa-user-md fa-fw"
                                                    type="select" 
                                                    optionsMode="json"
                                                    :optionsList="listaMedicos"
                                                    optionsData="" 
                                                    optionsDisplay="st_nome_exibicao"
                                                    :optionsSync="false"
                                                    v-model="dados.medico"
                                                    ref="info_medico"
                                                    @input="selecionarMedico (dados.medico)"
                                                    @onEnter="enterNoMedico ()" />

                                                <div v-if="subespecialidades && subespecialidades.length && !dados.medico">
                                                    <div class="my-1">
                                                        <button type="button" class="btn btn-sm"
                                                            :class="subesp.selecionado ? 'btn-success' : 'btn-outline-success'"
                                                            v-for="(subesp, isx) in subespecialidades" :key="isx"
                                                            @click="subesp.selecionado = !subesp.selecionado">
                                                            {{ subesp.tag }}
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="col col-12" v-if="pacienteMedicoStats && !dados.medico">

                                                <ul class="list-group">
                                                    <button type="button" class="list-group-item list-group-item-action list-group-item-light"
                                                        v-for="(item, id) in pacienteMedicoStats" :key="id"
                                                        @click="selecionarMedico (item.medico)">
                                                        {{ item.medico.st_nome_exibicao }}
                                                    </button>
                                                </ul>

                                            </div>

                                        </div>

                                    </template>

                                </template>

                            </template>

                        </div>

                        <div v-else>

                            <div class="card">
                                <div class="card-body text-center">
                                        <div class="display-4 my-3">Buscando horários...</div>

                                        <az-loading msg="Aguarde..." />

                                        <div class="spinner-border text-success mb-3" 
                                            style="width: 3rem; height: 3rem;"
                                            role="status" v-if="false">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- Agendamento de Demanda Espontânea -->

                    <div v-if="data">

                        <div v-if="dados.procedimento && dados.medico">

                            <cadastro-temporario v-model="cadastro_temporario" v-if="fluxo == 1" :validate="validarCadTemp" />

                            <div>
                                <az-sub-title title="Observação" />
                                <az-input type="text" v-model="st_observacoes" />
                            </div>

                            <div v-if="!hora">
                                <az-sub-title title="Horário" />
                                <label class="form form-control" v-if="!faixaHorarios.texto">
                                    Horário não disponível para esse profissional.
                                </label>
                                <az-input :label="faixaHorarios.texto" type="time" v-model="espontaneaHora" v-else />
                            </div>
                        
                            <div class="row d-flex justify-content-center mt-3 mb-3">

                                <div class="col col-12 d-flex flex-column">
                                    <az-submit :disabled="!espontaneaHora" @click="adicao_direta ()">
                                        Concluir
                                    </az-submit>
                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- Agendamento com seleção do horário -->

                    <div v-else class="mb-3">

                        <div class="row d-flex justify-content-center mt-3 mb-3" v-if="fluxo && !buscando">

                            <div class="col col-12 d-flex flex-column" v-if="( dados.procedimento || ( procedimentos && procedimentos.length ) )">
                                <button type="button" class="btn" :disabled="buscando || !pode_verificar_horarios || ( !dados.procedimento && !procedimentos.length )" 
                                    @click="buscarHorarios ()"
                                    :class="dados.procedimento || !procedimentos.length ? 'btn-outline-success' : 'btn-success'">
                                    <span class="spinner-border spinner-border-sm" v-if="buscando"></span>
                                    Verificar Horários Disponíveis
                                </button>
                            </div>

                        </div>

                        <historico-marcacoes 
                            v-if="agendar_para != 'P' && !is_ampiezza"
                            :portal="true"
                            :naoremarcar="true"
                            :historico="historicoMarcacoes" 
                            :autorizacao="historicoAutorizacao"
                            :poderevisar="true"
                            @remarcar="remarcar"
                            @refresh="load_mine()"
                            @revisao="marcar_revisao" />

                        <div class="mt-3 bg-white">
                            <span v-html="html_rodape"></span>
                        </div>

                    </div>

                </div>

                <div class="col col-12 col-md-12 col-lg-4" v-if="fluxo">

                    <template v-if="!aviso_final">

                        <div class="row mb-3" v-if="procedimentos && procedimentos.length">

                            <div class="col col-12">

                                <procedimentos-solicitados
                                    v-model="procedimentos"
                                    :cores="cores"
                                    :removeOnUnSelect="horarios ? false : true" />
                                
                            </div>

                        </div>

                        <az-instrucoes
                            :autorizacao="dadosRemarcacao ? dadosRemarcacao.autorizacao : null"
                            ref="instruc_conf"
                            :dados="dados" 
                            :cores="cores"
                            :procedimentos="data && dados.procedimento ? [dados] : procedimentos"
                            :historico="historicoMarcacoes ? historicoMarcacoes : []"
                            :pacotes="pacienteProcStats ? pacienteProcStats.pacotes : []"
                            :block_paciente="agendar_para == 'P'"
                            contexto="A"
                            v-model="podeMarcar" />

                    </template>

                </div>

            </div>

            <!-- Exibição dos HORÁRIOS encontrados -->

            <div class="row" v-if="horarios && !aviso_final">

                <div class="col col-12 col-md-8">

                    <div class="row">
                        <div class="col col-6 mb-3 d-flex flex-column" v-if="1 == 0">
                            <button type="button" class="btn btn-outline-secondary"> 
                                <i class="fas fa-stopwatch"></i>
                                {{ tempo }}
                            </button>
                        </div>

                        <div class="col col-12 mb-3 d-flex flex-column">
                            <button type="button" class="btn btn-outline-secondary" @click="voltar ()"> 
                                Voltar
                            </button>
                        </div>

                        <div class="col col-12">

                            <div v-if="dados.unidade_operacao" class="alert alert-secondary">
                                <strong>
                                    {{ dados.unidade_operacao.st_nome }}
                                </strong>
                            </div>

                        </div>

                    </div>

                    <div class="mb-3">

                        <AzEmptyState 
                            icon="far fa-calendar-times" 
                            msg="Nenhum horário disponível" 
                            v-if="!Object.keys(exibicao).length">
                        </AzEmptyState>

                        <ul class="list-group">
                            <template v-for="(dia, index) in exibicao">
                                <li :key="index" class="list-group-item" v-if="true">
                                    <div class="row">
                                        <div class="col col-12 col-md-2 d-flex flex-column justify-content-center align-items-center">
                                            <div class="text-primary">
                                                <h4 class="mb-0">
                                                    <a href="#" @click.prevent class="card-link">
                                                        <div>{{ getFormatDate (index, 'DD/MM') }}</div>
                                                    </a>
                                                </h4>
                                            </div>
                                            <div class="mb-2">
                                                <small class="text-muted">
                                                    {{ getFormatDate (index, 'dddd') }}
                                                </small>
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-10 text-center text-md-left">
                                            <div class="mb-2" v-for="(proca, ida) in dia" :key="ida">
                                                <button class="btn mr-1 mb-1"
                                                    :class="'btn-outline-' + cores[hora[0].index]"
                                                    data-toggle="tooltip" data-placement="top" title="Marcações Realizadas"
                                                    v-if="hora.length">
                                                    <i class="fas fa-list"></i>
                                                </button>
                                                <template v-for="(hora, ih) in grupo_hora(proca)">
                                                    <button :key="ih" @click="selecionar_hora(hora)" 
                                                        v-if="true"
                                                        class="btn mr-1 mb-1"
                                                        :class="'btn-' + ( check_marcado (hora) ? 'outline-' : '' ) + cores[hora[0].index]"
                                                        data-html="true"
                                                        data-toggle="tooltip" data-placement="top" :title="lista_hora(hora)">
                                                        <span v-if="hora.length > 0 && ( hora[0].ordem_chegada || hora[0].extra || hora[0].bloqueado )">
                                                            {{ hora[0].exibir }}
                                                        </span>
                                                        <span v-else>
                                                            {{ ih }}h
                                                        </span>
                                                    </button>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="1 == 0">
                                        <div class="col col-12">
                                            <pre>{{ grupo_hora_chaves (dia) }}</pre>
                                            <pre>{{ grupo_hora (dia) }}</pre>
                                        </div>
                                    </div>
                                </li>
                                <li :key="index + '-lim-rev'" class="list-group-item list-group-item-dark text-center" v-if="limite_revisao(index)">
                                    Prazo para revisão até {{ $util.getFormatDate(dt_prazo_revisao) }}
                                </li>
                            </template>
                        </ul>

                        <div class="mt-3 d-flex flex-column" v-if="!dt_prazo_revisao">
                            <button class="btn btn-outline-secondary" type="button" @click="buscarHorarios (true)" :disabled="buscando">
                                <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="buscando">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <span>Buscar mais horários {{ buscadoAte ? ' depois de ' + $util.getFormatDate(buscadoAte) : '' }}</span>
                            </button>
                        </div>

                        <div class="mt-3 d-flex flex-column" v-if="1 == 0">
                            <button class="btn btn-outline-secondary" type="button" 
                                v-if="this.dados.plano.id_operadora == 1">
                                Registrar Orçamento
                            </button>
                        </div>

                        <span v-if="1 == 0">{{ exibicao }}</span>

                    </div>

                    <div v-if="1 == 0"> 
                        <ul class="list-group">
                            <li class="list-group-item list-group-item-primary">{{ hora_selecionada[0].base }}h</li>
                            <li class="list-group-item d-flex align-items-center" v-for="(item, index) in grupo_hora_selecione ()" :key="index">
                                <h3 class="mr-2 pb-0">
                                    <span class="badge badge-primary">{{ index }}</span>
                                </h3>
                                <div>
                                    <button type="button" class="btn btn-success btn-sm mr-2" 
                                        v-for="(medico, im) in item" :key="im" @click="selecionar_horario (medico)">
                                        {{ medico.medico.st_nome_exibicao }}
                                    </button>
                                </div>
                            </li>
                        </ul>

                        <div class="mt-2" v-if="1 == 0 && horario_selecionado">

                            <CadastroTemporario v-if="!dados.paciente"></CadastroTemporario>
                            
                            <div class="row d-flex justify-content-center mt-3 mb-3">

                                <div class="col col-12 d-flex flex-column">
                                    <button type="button" class="btn btn-success">
                                        Concluir
                                    </button>
                                </div>

                            </div>

                        </div>
        
                    </div>

                </div>

                <!-- Filtros -->

                <div class="col col-12 col-md-4">

                    <div class="mb-3">
                        <ProcedimentosSolicitados 
                            v-model="procedimentos"
                            :cores="cores">
                        </ProcedimentosSolicitados>
                    </div>

                    <az-instrucoes
                        :autorizacao="dadosRemarcacao ? dadosRemarcacao.autorizacao : null"
                        ref="instrucoes"
                        :dados="dados" 
                        :cores="cores"
                        :procedimentos="procedimentos"
                        :historico="historicoMarcacoes"
                        :pacotes="pacienteProcStats ? pacienteProcStats.pacotes : []"
                        :block_paciente="agendar_para == 'P'"
                        contexto="A"
                        v-model="podeMarcar" />

                    <div>

                        <!-- Filtro por Unidade -->

                        <div class="card" style="padding: 0px;" v-if="$store.state.unidade.unidade_operacaos.length > 1 && unidades.length == 1">
                            <div class="card-header d-flex justify-content-between">
                                {{ unidades[0].search }}
                            </div>
                        </div>

                        <div class="card" style="padding: 0px;" v-if="unidades.length > 1">
                            <div class="card-header d-flex justify-content-between">
                                <a class="card-link" href="#" @click.prevent="filtro_collapse('col_unidades')">
                                    UNIDADES
                                </a>
                                <div>
                                    <span class="badge badge-secondary">
                                        {{ unidadesSelecionadas.filter (item => item).length }} / {{ unidades.length }}
                                    </span>
                                </div>
                            </div>
                            <div class="card-body collapse" id="col_unidades">
                                
                                <div class="row">

                                    <div class="col col-12">

                                        <div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="unidadeSwitchAll"
                                                    v-model="unidadesTodas" @click="marcar_unidade_todas ()">
                                                <label class="custom-control-label" for="unidadeSwitchAll">Todas</label>
                                            </div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0" v-for="(un, id) in unidades" :key="id">
                                                <input type="checkbox" class="custom-control-input" :id="'unidadeSwitch' + id"
                                                    v-model="unidadesSelecionadas[id]" value="abc">
                                                <label class="custom-control-label" :for="'unidadeSwitch' + id">
                                                    {{ un.search }}
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                        <div class="card" style="padding: 0px;">
                            <div class="card-header">
                                Filtros
                            </div>

                            <div class="card-body">

                                <div class="row">

                                    <div class="col col-12 col-lg-4">

                                        <div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="customSwitchAll"
                                                    v-model="diasTodos" @click="marcar_dias_todos ()">
                                                <label class="custom-control-label" for="customSwitchAll">Todos</label>
                                            </div>
                                            <div class="custom-control custom-switch  mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                                    v-model="diasDaSemana[0]">
                                                <label class="custom-control-label" for="customSwitch1">Dom</label>
                                            </div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="customSwitch2"
                                                    v-model="diasDaSemana[1]">
                                                <label class="custom-control-label" for="customSwitch2">Seg</label>
                                            </div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="customSwitch3"
                                                    v-model="diasDaSemana[2]">
                                                <label class="custom-control-label" for="customSwitch3">Ter</label>
                                            </div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="customSwitch4"
                                                    v-model="diasDaSemana[3]">
                                                <label class="custom-control-label" for="customSwitch4">Qua</label>
                                            </div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="customSwitch5"
                                                    v-model="diasDaSemana[4]">
                                                <label class="custom-control-label" for="customSwitch5">Qui</label>
                                            </div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="customSwitch6"
                                                    v-model="diasDaSemana[5]">
                                                <label class="custom-control-label" for="customSwitch6">Sex</label>
                                            </div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="customSwitch7"
                                                    v-model="diasDaSemana[6]">
                                                <label class="custom-control-label" for="customSwitch7">Sab</label>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="col col-12 col-lg-8">

                                        <div>
                                            <label for="customRange1" class="d-flex justify-content-between">
                                                <span>Faixa Inicial de Horário</span>
                                                <span class="badge badge-secondary">{{ faixaInicio }}h</span>
                                            </label>
                                            <input type="range" class="custom-range" min="0" max="24" step="1" v-model="faixaInicio">
                                        </div>
                                            
                                        <div>
                                            <label for="customRange1" class="d-flex justify-content-between">
                                                <span>Faixa Final de Horário</span>
                                                <span class="badge badge-secondary align-items-center">{{ faixaFim }}h</span>
                                            </label>
                                            <input type="range" class="custom-range" min="0" max="24" step="1" v-model="faixaFim">
                                        </div>

                                        <div class="d-flex flex-column mt-3">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-secondary btn-sm" 
                                                    @click="faixaInicio = 8; faixaFim = 12;">Manhã</button>
                                                <button type="button" class="btn btn-secondary btn-sm"
                                                    @click="faixaInicio = 14; faixaFim = 18;">Tarde</button>
                                                <button type="button" class="btn btn-secondary btn-sm"
                                                    @click="faixaInicio = 0; faixaFim = 24;">Geral</button>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                        <div class="card" style="padding: 0px;">
                            <div class="card-header">
                                Médicos
                            </div>
                            <div class="card-body">

                                <div class="row">

                                    <div class="col col-12">

                                        <div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0">
                                                <input type="checkbox" class="custom-control-input" id="medicoSwitchAll"
                                                    v-model="medicosTodos" @click="marcar_medicos_todos ()">
                                                <label class="custom-control-label" for="medicoSwitchAll">Todos</label>
                                            </div>
                                            <div class="custom-control custom-switch mb-2 mb-md-0" v-for="(md, id) in medicos" :key="id">
                                                <input type="checkbox" class="custom-control-input" :id="'medicoSwitch' + id"
                                                    v-model="medicosSelecionados[id]" value="abc">
                                                <label class="custom-control-label" :for="'medicoSwitch' + id">
                                                    {{ md.st_nome_exibicao }}
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <!-- Seleção de Horário Final (hora, minuto e médico) -->
            <div class="modal fade" id="minutoModal" tabindex="-1" role="dialog" aria-labelledby="minutoModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel" v-if="hora_selecionada">
                                {{ getHumanDate (hora_selecionada[0].data, 'dddd') }} | 
                                {{ getFormatDate (hora_selecionada[0].data, 'dddd') }} | 
                                {{ hora_selecionada[0].base }}h
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">

                            <template v-if="false">

                            <div v-for="(horarios, id, idx) in grupo_medico_selecione()" :key="idx">
                                <div class="row">
                                    <template v-if="cc">
                                        <div class="col col-12 col-md-8">
                                            <div v-if="horarios[0] && horarios[0].unidade_operacao" class="text-muted">
                                                {{ horarios[0].unidade_operacao.search }}
                                            </div>
                                            <div>
                                                {{ id }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col col-12 col-md-2 text-center">
                                            <avatar
                                                class="ml-3"
                                                :username="get_medico(id, 'st_nome_exibicao')"
                                                :src="get_medico(id, 'logo.arquivo.temporary_url')"
                                                :size="100"></avatar>
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <template v-if="get_medico(id, 'st_assinatura')">
                                                <span class="" v-html="$util.nl2br(get_medico(id, 'st_assinatura'))"></span>
                                            </template>
                                            <template v-else>
                                                <div>{{ get_medico(id, 'st_nome_exibicao') }}</div>
                                                <div>{{ get_medico(id, 'numero_formatado') }}</div>
                                            </template>

                                            <div v-if="get_medico(id, 'st_sub_especialidade')">
                                                <i class="fas fa-certificate mr-2"></i>
                                                {{ get_medico(id, 'st_sub_especialidade') }}
                                            </div>

                                            <div v-if="get_medico(id, 'medico_unidade.st_instrucao')">
                                                <blockquote class="blockquote mb-0">
                                                    <footer class="blockquote-footer text-nowrap text-truncate" :id="'instr-proc-sel-med-' + idx"
                                                        @mouseover="hover('instr-proc-sel-med-' + idx, true)"
                                                        @mouseleave="hover('instr-proc-sel-med-' + idx, false)">
                                                        {{ get_medico(id, 'medico_unidade.st_instrucao') }}
                                                    </footer>
                                                </blockquote>
                                            </div>
                                            <div v-if="false && get_ocupados(id, 'ocupados') > 0">
                                                <span class="badge badge-secondary" title="Marcados">
                                                    {{ get_ocupados(id, 'ocupados') }}
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="col col-12 col-md-4">
                                        <div v-for="(horarios_por_unidade, horarios_unidade, ihux) in agrupar(horarios, 'unidade_operacao.search')" :key="ihux">
                                            <div v-if="$store.state.unidade.unidade_operacaos.length > 1 && !cc">{{ horarios_unidade }}</div>
                                            <span class="mr-2 mb-2" v-for="(horario, ihx) in horarios_por_unidade" :key="ihx">
                                                <button type="button" class="btn btn-sm btn-success"
                                                    :disabled="$store.state.loading"
                                                    @click="selecionar_horario (horario, $store.state.unidade.unidade_operacaos.length > 1 ? horario.unidade_operacao.search : '')">
                                                    <i class="fa fa-ban mr-2" aria-hidden="true" v-if="horario.teto && !horario.teto_livre"></i>
                                                    <i class="fa fa-exclamation-circle mr-2" aria-hidden="true" v-else-if="horario.teto && horario.teto_livre"></i>
                                                    <i class="fas fa-satellite-dish mr-1" v-if="horario.tele"></i>
                                                    {{ horario.hg ? horario.hg : horario.hora }}
                                                    <span class="ml-2" v-if="horario.tipo_consulta == 'R'">
                                                        <i class="fa fa-registered" aria-hidden="true"></i>
                                                    </span>
                                                    <span class="ml-2" v-if="horario.paralela && !cc">
                                                        {{ horario.titulo }}
                                                    </span>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                            </div>

                            </template>

                            <ul class="list-group" v-if="hora_selecionada">
                                <li class="list-group-item d-flex align-items-center" v-for="(item, index) in grupo_hora_selecione ()" :key="index">
                                    <div class="mr-2">
                                        <label class="form form-control text-center" style="width: 100px">
                                            <i class="far fa-clock"></i>
                                            {{ ( item && item[0] && item[0].hg ) ? item[0].hg : index }}
                                        </label>         
                                    </div>
                                    <div>
                                        <button type="button" class="btn btn-success mr-2 mb-2" 
                                            v-for="(medico, im) in medicosParaMarcar(item)" :key="im" 
                                            @click="selecionar_horario (medico, $store.state.unidade.unidade_operacaos.length > 1 ? medico.unidade_operacao.search : '')">
                                            {{ medico.medico.st_nome_exibicao }}
                                            <span v-if="$store.state.unidade.unidade_operacaos.length > 1">/ {{ medico.unidade_operacao.search }}</span>
                                        </button>
                                    </div>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>

            <!-- Confirmacão Final -->
            <div class="modal fade" id="cadastroModal" tabindex="-1" role="dialog" aria-labelledby="cadastroModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header" v-if="procedimentos">
                            <h5 class="modal-title" id="exampleModalLabel" v-if="hora_selecionada">
                                Confirmar
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" v-if="procedimentos">

                            <procedimentos-solicitados
                                v-model="procedimentos"
                                :cores="cores" 
                                :listOnly="true"
                                :ordem="true" />

                            <div class="alert alert-warning mt-3" v-if="agendar_para == 'P' && $store.state.user.st_tipo != 'X'">
                                <strong>
                                    <i class="fa-solid fa-triangle-exclamation mr-2"></i>
                                    Agendamento para outra pessoa. Informar os dados do paciente que será atendido.
                                </strong>
                            </div>

                            <div class="mt-3" v-if="!dados.paciente">
                                <cadastro-temporario 
                                    v-model="cadastro_temporario" 
                                    :validate="validarCadTemp" 
                                    :coletar_matricula="dados.plano && dados.plano.id_operadora && dados.plano.id_operadora != 1" />
                            </div>

                            <div class="mt-3" v-else>

                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <az-input label="Nome do Paciente"
                                            type="text" 
                                            :rules="['nome']"
                                            :validate="validarCadTemp"
                                            :edicao="false"
                                            v-model="dados.paciente.st_nome" 
                                            required />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input label="Nome Social"
                                            type="text" 
                                            :rules="['nomenum']"
                                            :validate="validarCadTemp"
                                            v-model="dados.paciente.st_nome_social" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            label="Sexo" 
                                            type="sexo" 
                                            required
                                            :validate="validarCadTemp"
                                            v-model="dados.paciente.cadastro.ch_sexo" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            label="Data de Nascimento" 
                                            type="date" 
                                            required
                                            v-model="dados.paciente.cadastro.dt_nascimento"
                                            :validate="validarCadTemp" 
                                            :rules="['nasc']" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input 
                                            label="e-mail" 
                                            type="email" 
                                            :edicao="false"
                                            v-model="dados.paciente.cadastro.st_email" 
                                            :validate="validarCadTemp" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <az-input label="Telefone"
                                            type="fone" 
                                            :validate="validarCadTemp"
                                            v-model="dados.paciente.cadastro.telefones.telefone" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input label="Celular"
                                            type="fone" 
                                            :validate="validarCadTemp"
                                            v-model="dados.paciente.cadastro.telefones.celular" />
                                    </div>
                                </div>

                                <!-- Confirmação dos dados da operadora -->
                                <template v-if="dados.plano && dados.plano.id_operadora && dados.plano.id_operadora != 1">
                                    <div class="row" v-if="dados.paciente.paciente_unidade">
                                        <div class="col col-12 col-md-6">
                                            <div class="form-group">
                                                <az-input
                                                    label="No. da Carteira do Plano"
                                                    :required="matricula_obrigatoria"
                                                    :validate="validarCadTemp"
                                                    v-model="dados.paciente.paciente_unidade.st_numero_carteira" />
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <div class="form-group">
                                                <az-input
                                                    label="Validade da Carteira"
                                                    type="date"
                                                    :required="matricula_obrigatoria"
                                                    :validate="validarCadTemp"
                                                    v-model="dados.paciente.paciente_unidade.dt_validade_carteira" />
                                            </div>
                                        </div>
                                    </div>    

                                    <div class="row" v-else>
                                        <div class="col col-12 col-md-6">
                                            <div class="form-group">
                                                <az-input
                                                    label="No. da Carteira do Plano"
                                                    :required="matricula_obrigatoria"
                                                    :validate="validarCadTemp"
                                                    v-model="dados.paciente.st_numero_carteira" />
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <div class="form-group">
                                                <az-input
                                                    label="Validade da Carteira"
                                                    type="date"
                                                    :required="matricula_obrigatoria"
                                                    :validate="validarCadTemp"
                                                    v-model="dados.paciente.dt_validade_carteira" />
                                            </div>
                                        </div>
                                    </div>    
                                </template>

                            </div>

                            <div class="mt-3">
                                <az-sub-title title="Observação" />
                                <div class="row">
                                    <div class="col col-12" :class="tem_tele_atendimento ? 'col-md-8' : ''">
                                        <az-input type="text" v-model="st_observacoes" />
                                    </div>
                                    <div class="col col-12 col-md-4" v-if="tem_tele_atendimento">
                                        <az-input type="checkbox-group" label="Teleatendimento" v-model="fl_tele_atendimento" />
                                    </div>
                                </div>
                            </div>

                            <!-- Anexos -->
                            <div class="mt-3" v-if="dados && dados.reserva && dados.reserva.doc_reqs && dados.reserva.doc_reqs.length">
                                <az-sub-title title="Anexos Requeridos" />
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(req, irx) in dados.reserva.doc_reqs" :key="irx">
                                        <div>{{ req.st_mensagem }}</div>
                                        <az-single-image-loader 
                                            :chave="'imagem_' + irx"
                                            titulo="Arquivo" 
                                            :single="true" 
                                            :arquivo="req.arquivo" 
                                            :parms="{ 
                                                model_type: 'reservaHorario', 
                                                model_id: dados.reserva.id_reserva_horario,
                                                tipo_especial: 'R' + req.id_anexo_requerido, 
                                                id_tipo_arquivo: req.id_tipo_arquivo
                                            }" 
                                            :pode_pdf="true"
                                            service="reserva_horarios"
                                            @sync="vincular_arquivo(req, $event)">
                                        </az-single-image-loader>
                                    </li>
                                </ul>
                            </div>

                            <!-- Formulários de Pré-Atendimento -->
                            <div class="mt-3" v-if="dados && dados.doc_pre_atends && dados.doc_pre_atends.length">
                                <pre-atendimento-edit 
                                    v-model="dados.doc_pre_atends" 
                                    :validate="validarCadTemp" />
                            </div>

                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Voltar</button>
                            <az-submit @click="marcar()">Confirmar</az-submit>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Resumo da Marcação Realizada -->
            <div class="modal fade" id="resumoModal" tabindex="-1" role="dialog" aria-labelledby="resumoModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content" v-if="resumo">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel" v-if="hora_selecionada">
                                Resumo
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">

                            <ProcedimentosSolicitados 
                                v-model="resumo.procedimentos"
                                :cores="cores">
                            </ProcedimentosSolicitados>

                            <div class="mt-3" v-if="resumo.cadastro_temporario">
                                <CadastroTemporario :edicao="false" v-model="resumo.cadastro_temporario"></CadastroTemporario>
                            </div>

                            <div class="mt-3" v-if="resumo.paciente">
                                <pre>{{ resumo.paciente }}</pre>
                            </div>

                            <p class="alert alert-sucess">Marcação realizada!</p>



                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

        </template>

    </template>

    <!-- Modal -->
    <div class="modal fade" id="instrucaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Atenção</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <span v-html="informacao"></span>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Instrução Procedimento -->
    <div class="modal fade" id="cienteInstrucoesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Atenção</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="instrucoes_ciente">
                    <h4 v-if="procedimentos && procedimentos[0] && procedimentos[0].procedimento">
                        {{ procedimentos[0].procedimento.search }}
                    </h4>
                    <div v-for="(inst, iix) in instrucoes_ciente" :key="iix" 
                        class="alert alert-info lead mt-3 mb-0 font-weight-bold">
                        <span v-html="inst.text"></span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-success" @click="ciente_instrucoes()">Ciente</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Informações -->
    <div class="modal fade" id="infoPacienteOutroModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" v-if="dados">
                <div class="modal-header">
                    <h5 class="modal-title">Informações</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <az-input
                        label="Data de Nascimento"
                        type="date"
                        v-model="dados.dt_nascimento" />
                    
                    <az-input
                        class="mt-3"
                        label="Sexo"
                        type="radio-v"
                        :optionsList="[
                            { id: 'M', search: 'Masculino' },
                            { id: 'F', search: 'Feminino' },
                        ]"
                        optionsData="id"
                        v-model="dados.ch_sexo" />

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-success" @click="confirmar_info_outro()">Confirmar</button>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';
import CadastroTemporario from '../modulos/callcenter/CadastroTemporario.vue';
import AzInstrucoes from '../util/AzInstrucoes.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import AzSubTitle from '../util/AzSubTitle.vue';
import AzSubmit from '../util/AzSubmit.vue';
import ProcedimentosSolicitados from '../modulos/callcenter/ProcedimentosSolicitados.vue';
import HistoricoMarcacoes from '../modulos/callcenter/HistoricoMarcacoes.vue';
import { setInterval } from 'timers';
import AzLoading from '../util/AzLoading.vue';
import PreAtendimentoEdit from '../modulos/recepcao/PreAtendimentoEdit.vue';
import Avatar from 'vue-avatar'
import AzSingleImageLoader from '../util/AzSingleImageLoader.vue';

export default {
    data () { 
        return { 

            dados: { 
                plano: { id_plano: "", id_operadora: "" }, 
                especialidade: "", 
                tipoProcedimento: "", 
                medico: "", 
                procedimento: "", 
                unidade_operacao: "", 
                consultas: [], 
                tipo_pagamento: "", 
                dt_nascimento: "", 
                ch_sexo: "", 
            },
            fluxo: 1,
            procedimentos: [],
            cadastro_temporario: {},
            buscando: false,
            horarios: null,
            teste: null,
            hora_selecionada: null,
            horario_selecionado: null, 

            st_observacoes: null, 

            podeMarcar: true, 

            historicoMarcacoes: null, 

            faixaInicio: 0,
            faixaFim: 24,
            diasDaSemana: [true, true, true, true, true, true, true],
            diasTodos: true,
            medicosSelecionados: [],
            medicosTodos: true,
            unidadesTodas: true, 
            unidadesSelecionadas: [], 

            pacienteProcStats: null, 
            pacienteMedicoStats: null,
            listaMedicos: [],

            faixaHorarios: {},
            espontaneaHora: null,
            
            tmaInicio: null, 
            tmaFim: null,
            tmaInterval: null, 

            resumo: null,

            cores: [ 'success', 'info', 'warning', 'secondary', 'danger', 'primary' ],
            anime: true,

            validarCadTemp: false,
            aviso_final: null,

            dadosRemarcacao: null, 
            especialidades: [],
            subespecialidades: null,

            minhas: null,

            buscadoAte: "",
            configs: null, 

            lista_planos: [],
            lista_operadoras: [], 

            informacao: null, 

            instrucoes_ciente: [], 
            lista_medicos_agenda: [],

            cc: false, 

            agendar_para: 'M', 
            id_plano_padrao: null, 

            block_alterar_plano: false, 
            dt_prazo_revisao: null, 

            historicoAutorizacao: null,
            fl_tele_atendimento: false, 

            config_apenas_cons: false, 
            config_apenas_proced: false, 
            config_portal_unidade_obrig: false, 
            config_block_sel_medico: false, 
            
        }
    },

    props: { 
        data: { 
            type: String,
            default: ""
        },
        hora: { 
            type: String,
            default: ""
        },
        modalName: { 
            type: String,
            default: ""
        },
        tipoFluxo: { 
            type: String,
            default: "marcacao",
        },
        remarcacao: { 
            default: null,
        },
        apenas_particular: { 
            default: false,
        },
        nao_marcar_por_outro: { 
            default: false,
        }
    },

    components: { 
        AzInput,
        AzInstrucoes,
        AzEmptyState,
        AzSubTitle,
        AzSubmit,
        CadastroTemporario,
        ProcedimentosSolicitados,
        HistoricoMarcacoes,
        AzLoading,
        PreAtendimentoEdit,
        AzSingleImageLoader, 
        Avatar, 
    },

    watch: { 
        diasDaSemana: function (newValue) {
            
            let teste = newValue.findIndex(i => { 
                        return !i;
                    });

            this.diasTodos = !( teste >= 0);
                    
        },

        medicosSelecionados: function (newValue) {

            let teste = newValue.findIndex(i => { 
                        return !i;
                    });

            this.medicosTodos = !( teste >= 0);

        },

        unidadesSelecionadas: function (newValue) { 

            let teste = newValue.findIndex(i => { 
                        return !i;
                    });

            this.unidadesTodas = !( teste >= 0);

        },
    },

    computed: {
        is_proc_lista: function () { 
            return window.redir == 'teste' || window.redir == 'dnagenetica' || window.redir == 'dnateste';
        },

        is_ampiezza: function () { 
            return window.redir == 'teste2' || window.redir == 'ampiezza' || window.redir == 'fisiotrauma';
        },

        matricula_obrigatoria: function () { 
            if ( !this.configs )
                return;

            return this.configs.find(item => item.st_slug == 'portal-obrig-matricula' && item.st_valor == '1') ? true : false;
        },

        pode_verificar_horarios() { 
            return ( this.fluxo && this.dados.plano && this.dados.plano.id_plano ) && 
                ( ( this.dados.tipoProcedimento == 'C' && this.dados.especialidade && this.dados.procedimento )
                || ( this.dados.tipoProcedimento != 'C' ) );
        },

        html_rodape: function () { 
            if ( !this.configs )
                return;

            let html = this.configs.find(item => item.st_slug == 'portal-agenda-html-rodape');

            return html ? html.st_valor : '';
        },
        mensagem: function () { 
            if ( !this.configs )
                return "";

            let config = this.configs.find(item => item.st_slug == 'portal-agenda-msg');

            if ( config )
                return config.exibir;

            return "";
        },

        lista_operadoras_exibir: function () { 
            if ( !this.lista_operadoras )
                return [];

            return this.lista_operadoras.filter(item => ( this.dados.tipo_pagamento == 'P' && item.id_operadora == 1 )
                    || ( this.dados.tipo_pagamento == 'O' && item.id_operadora > 1 ) ) 
                .filter(item => !this.dados.unidade_operacao 
                    || !item.unidade_operadoras.find(uo => uo.id_unidade_operacao == this.dados.unidade_operacao.id_unidade_operacao && !uo.fl_ativo)
            );
        },

        lista_planos_exibir: function () { 
            if ( !this.dados || !this.dados.plano || !this.dados.plano.id_operadora )
                return [];

            return this.lista_planos.filter(item => item.id_operadora == this.dados.plano.id_operadora)
                .filter(item => !this.dados.unidade_operacao 
                    || !item.unidade_operacao_planos
                    || !item.unidade_operacao_planos.find(uo => uo.id_unidade_operacao == this.dados.unidade_operacao.id_unidade_operacao && !uo.fl_ativo)
                );
        },


        lista_especialidades: function () { 

            if ( !this.especialidades )
                return [];

            let plano = null;

            if ( this.dados.plano.id_plano && this.$store.state.options['planos.index'] ) { 
                plano = this.$store.state.options['planos.index'].find(item => item.id_plano == this.dados.plano.id_plano);
            }

            return plano && plano.id_operadora !=  1 ? this.especialidades.filter(item => 
                item.operadoras.findIndex(mo => mo.id_operadora == plano.id_operadora) >= 0) 
                : this.especialidades;

        },

        tempo: function () { 

            let now = moment(this.tmaFim, "HH:mm:ss"); 
            let end = moment(this.tmaInicio, "HH:mm:ss"); 
            let diff = now.diff(end);
            //var duration = moment.duration(now.diff(end)); // .humanize();

            let duration = moment.utc(diff).format("mm:ss");

            return duration;

        },

        medicos: function () { 

            if ( !this.horarios )
                return [];

            return _.uniqBy(
                _.map(this.horarios, function (item) { 
                    return item.medico;
                }),
                function (item) { 
                    return item.id_pessoa;
                }
            );

        },

        exibicao: function () { 

            if ( !this.horarios )
                return 'Sem horários...';

            let self = this;
            let diasDaSemana = this.diasDaSemana;
            
            let filtro_dia = _.filter(this.horarios, function(item) { 
                return diasDaSemana[moment(item.data, 'YYYY-MM-DD').format('d')] && 
                        item.status == 'livre' && 
                        self.procedimentos[item.index].selected && 
                        ( 
                            !self.medicosSelecionados.length || 
                            self.medicosSelecionados[_.findIndex(self.medicos, function (md) { 
                                return md.id_pessoa == item.medico.id_pessoa;
                            })]
                        )&& 
                        ( 
                            !self.unidadesSelecionadas.length || 
                            self.unidadesSelecionadas[_.findIndex(self.unidades, function (un) { 
                                return un.id_unidade_operacao == item.id_unidade_operacao;
                            })]
                        );
            });

            filtro_dia = _.orderBy(filtro_dia, ['data', 'index', 'hora'], ['asc', 'asc', 'asc']);
            
            let dias = filtro_dia.reduce((result, item) => {

                // Get app object corresponding to current item from result (or insert if not present)
                var app = result[item.data] = result[item.data] || {};

                // Get type array corresponding to current item from app object (or insert if not present)
                var type = app[item.procedimento.st_procedimento] = app[item.procedimento.st_procedimento] || [];

                // Add current item to current type array
                type.push(item);

                // Return the result object for this iteration
                return result;

                }, {});

            // let dias = _.groupBy(filtro_dia, ['data', 'base']);
            
            return dias;
            
        },

        procStats: function () { 

            return this.pacienteProcStats && this.pacienteProcStats.procedimentos && 
                    this.pacienteProcStats.procedimentos.length ? 
                    this.pacienteProcStats.procedimentos : 
                    ( this.$store.state.options.marcacoesStats ?
                        this.$store.state.options.marcacoesStats.procedimentos : null );

        },

        unidades: function () { 

            if ( !this.horarios )
                return [];

            return _.uniqBy(
                _.map(this.horarios, function (item) { 
                    return item.unidade_operacao ? item.unidade_operacao : { id_unidade_operacao: null };
                }),
                function (item) { 
                    return item.id_unidade_operacao;
                }
            ).filter(item => item.id_unidade_operacao);

        },

        pode_buscar_horarios: function () { 

            if ( this.fluxo && !this.buscando ) { 
                if ( this.dados.procedimento || ( this.procedimentos && this.procedimentos.length ) ) { 
                    if ( this.pode_verificar_horarios ) { 
                        return true;
                    }
                }
            }

            return false;
        },

        tem_tele_atendimento: function () {
            return this.$store.state.options && this.$store.state.options.marcacoesStats && this.$store.state.options.marcacoesStats.tele_atendimento;
        },

    },

    methods: { 
        finalizar_marcacao () { 

        },

        remarcar (marcacao) { 
            this.dadosRemarcacao = marcacao;

            this.dados.id_solicitacao_autorizacao = marcacao.id_solicitacao_autorizacao;

            this.dados.unidade_operacao = this.$store.state.unidade.unidade_operacaos.find(uo => uo.id_unidade_operacao == marcacao.id_unidade_operacao) || "";

            //this.dados.paciente = marcacao.paciente;
            //this.selecionarPaciente();

            this.dados.plano = marcacao.plano;
            this.selecionarPlano(this.dados.plano);

            this.dados.procedimento = marcacao.procedimento;
            this.selecionarProcedimento(this.dados.procedimento);

            if ( marcacao.recorrencias ) { 
                this.dados.medico = marcacao.medico;
                this.selecionarMedico(this.dados.medico);
            }

            this.buscarHorarios ();

            console.log('remarcar', marcacao);
        },

        vincular_arquivo (req, arquivo) { 
            req.arquivo = arquivo;

            this.$forceUpdate();
        },

        confirmar_info_outro () { 

            if ( !this.dados.dt_nascimento ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Informe a data de nascimento.",
                    life: 3000
                });
                return;
            }

            if ( !this.dados.ch_sexo ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Informe o sexo.",
                    life: 3000
                });
                return;
            }

            $('.modal').modal('hide');

            if ( this.pode_buscar_horarios ) { 
                this.buscarHorarios();
            }


        },

        limite_revisao(data) {

            if ( this.dt_prazo_revisao && data <= this.dt_prazo_revisao ) {
                let datas = Object.keys(this.exibicao);
                return datas.find(item => item > data && item <= this.dt_prazo_revisao) ? false : true;
            }

            return false;

        },

        marcar_revisao (marcacao) { 

            console.log('marcar_revisao', marcacao);
            console.log('especialidades', this.lista_especialidades);

            this.dados.tipoProcedimento = 'C';

            let espec = this.lista_especialidades.find(item => item.id_especialidade == marcacao.procedimento.id_especialidade);

            if ( espec ) { 
                this.dados.especialidade = espec;
                this.verificarTipoProcedimento();

                console.log('listaMedicos', this.listaMedicos);

                this.dados.medico = marcacao.medico;
            }
             
        },

        alterar_agendar_para () { 
            if ( this.agendar_para == 'P' ) { 
                this.dados.paciente = null;
            } else { 
                this.dados.paciente = this.$store.state.user.pessoa;
            }
        },

        agrupar(lista, campo) {
            return _.groupBy(lista, item => _.get(item, campo));
        },

        get_medico(id, info = null) {
            let medico = this.lista_medicos_agenda.find(item => item.id_pessoa == id)
            return info ? _.get(medico, info) : medico;
        },

        grupo_medico_selecione () {

            return this.cc 
                ? _.groupBy(this.hora_selecionada, item => item.local_nome)
                : _.groupBy(this.hora_selecionada, item => item.medico.id_pessoa);

        },

        selecionarTipoPagamento() { 

            if ( this.dados.tipo_pagamento == 'P' ) { 

                if ( !this.dados.plano ) { 
                    this.dados.plano = { 
                        id_operadora: 1, 
                        id_plano: null, 
                    };
                }

                this.dados.plano.id_operadora = 1;

            } else if ( this.dados.plano && this.dados.plano.id_operadora ) { 

                this.dados.plano.id_operadora = "";

            }

        },

        marcar_unidade_todas () { 

            let base = !this.unidadesTodas;
            let tmp = [];

            _.forEach(this.unidades, function (item, index) { 
                tmp[index] = base;
            });

            this.unidadesSelecionadas = tmp;

        },

        filtro_collapse(id) {
            $('#' + id).collapse('toggle');
        },

        verificarTipoProcedimento () { 

            if ( this.dados.tipoProcedimento == 'C' || this.config_apenas_cons ) { 

                this.dados.consultas = [];
                this.listaMedicos = [];

                this.$util.loadItem(this, { 
                    service: 'procedimentos.index', 
                    parms: { 
                        where: { 
                            id_especialidade: this.dados.especialidade ? this.dados.especialidade.id_especialidade : -1,
                        },
                        search: 'CONSULTA', //  MEDICA', 
                        consulta: true, 
                        ativos: true, 
                        size: 100, 
                        agenda_on_line: true, 
                    }
                })
                .then(res => { 
                    if ( this.dados.tipoProcedimento == 'C' && res && res.length ) { 
                        this.dados.consultas = res;

                        if ( res.length == 1 ) { 
                            this.dados.procedimento = res[0];
                            this.selecionarProcedimento (this.dados.procedimento);
                        } else { 
                            this.dados.procedimento = null;
                        }
                    } else { 
                        this.dados.procedimento = null;
                    }
                });

            } else { 

               this.$nextTick(() => { 
                   this.dados.procedimento = "";
               });

            }

        },

        medicosParaMarcar (lista) { 
            return _.uniqBy(lista, item => item.medico.id_pessoa);
        },

        log (dado) {
            console.log(dado);
        },

        selecionarPaciente () { 

            this.$nextTick(() => {

                if ( this.dados.paciente ) { 

                    this.focusOn ('info_plano');

                    if ( this.id_plano_padrao ) { 
                        this.dados.plano = { id_plano: this.id_plano_padrao }; 
                        this.tipo_pagamento = 'P';
                    } else { 
                        this.dados.plano = this.dados.paciente.paciente_unidade.plano;
                            
                        if ( this.dados.plano ) { 
                            this.tipo_pagamento = ( this.dados.plano.id_operadora == 1 ? 'P' : 'O' ) ;
                        }
                    }

                    let query = { q: [ 
                        { 
                            name: 'marcacoes.stats',
                            id: 'stats',
                            parms: { 
                                fl_paciente: true,
                                // id_paciente: this.dados.paciente.id_pessoa,
                            }
                        }
                    ]};

                    this.axios.post('/aql', query)
                        .then(res => { 
                            if ( res.data.stats.status == 200 ) {
                                this.pacienteProcStats = res.data.stats.data;
                                this.historicoMarcacoes = res.data.stats.data.marcacoes;
                                this.historicoAutorizacao = res.data.stats_pac.data.autorizacao;
                            }
                        });
                }

            });

        },

        tmaCount () { 
            this.tmaFim = moment().format('HH:mm:ss');
        },

        startFluxo (fluxo) { 

            this.tmaInicio = moment().format('HH:mm:ss');
            this.tmaFim = this.tmaInicio;
            this.fluxo = fluxo;
            this.dados.paciente = this.$store.state.user.st_tipo == 'X' ? null : this.$store.state.user.pessoa;

            if ( this.$store.state.user.st_tipo != 'X' ) { 

                if ( this.$store.state.user.pessoa.paciente_unidade && this.$store.state.user.pessoa.paciente_unidade.plano ) { 
                    this.dados.plano = this.$store.state.user.pessoa.paciente_unidade.plano;
                    this.selecionarPlano(this.dados.plano); 
                }

            }

            if ( !this.dados.plano ) { 

                this.dados.plano = { 
                    id_operadora: null,
                    id_plano: null
                };

            }

            if ( this.tmaInterval ) { 
                clearInterval ( this.tmaInterval );
            }

            this.tmaInterval = setInterval(() => {
                this.tmaFim = moment().format('HH:mm:ss');
            }, 1000);

            if ( fluxo == 1 ) { 

                this.$nextTick(() => {
                    this.focusOn('info_plano');
                });
                
            } else { 

                this.$nextTick(() => {
                    this.focusOn('info_paciente');
                });

            }

        },

        selecionarPlano (plano) { 

            this.dados.plano = plano;

            if ( plano ) {
                this.dados.tipo_pagamento = ( plano.id_operadora == 1 ? 'P' : 'O' );
            }   

            this.$nextTick(() => {
                this.focusOn('info_procedimento');

                if ( this.$store.state.user.info && this.$store.state.user.info.proc ) { 
                    this.dados.tipoProcedimento = 'P';

                    this.$util.loadItem(this, { 
                        service: 'procedimentos',
                        func: 'show',
                        parms: { 
                            id: this.$store.state.user.info.proc,
                        }
                    })
                    .then(res => { 
                        this.selecionarProcedimento(res);
                    });
                } else if ( this.$store.state.user.info && this.$store.state.user.info.esp ) { 
                    this.dados.tipoProcedimento = 'C';

                    setTimeout(() => {
                        console.log('lista', this.lista_especialidades);
    
                        let espec = this.lista_especialidades.find(item => item.id_especialidade == this.$store.state.user.info.esp);
    
                        if ( espec ) { 
                            console.log('espec', espec);
                            this.dados.especialidade = espec;
                            this.verificarTipoProcedimento();
                        }
                    }, 1000);

                }
            });

        },

        selecionarProcedimento (procedimento) { 

            this.dados.procedimento = procedimento;
            this.listaMedicos = [];
            
            this.$nextTick(() => {
                this.focusOn('info_medico');
            });

            if ( procedimento ) { 

                let query = { q: [ 
                    { 
                        name: 'marcacoes.stats',
                        id: 'stats',
                        parms: { 
                            id_plano: this.dados.plano.id_plano,
                            id_procedimento: procedimento.id_procedimento,
                        }
                    }
                ]};

                this.axios.post('/aql', query)
                    .then(res => { 
                        if ( res.data.stats.status == 200 ) {
                            if ( res.data.stats.data.medicos ) { 
                                this.listaMedicos = res.data.stats.data.medicos;
                                this.subespecialidades = res.data.stats.data.classes;

                                if ( this.dados.medico ) { 
                                    let med = this.listaMedicos.find(item => item.id_pessoa == this.dados.medico.id_pessoa);

                                    if ( med ) { 
                                        this.dados.medico = med;
                                    }
                                }
                            }
                        }
                    });

            } else { 

                this.subespecialidades = null;

            }

            if ( this.dados.paciente ) { 

                let query = { q: [ 
                    { 
                        name: 'marcacoes.stats',
                        id: 'stats',
                        parms: { 
                            fl_paciente: true, 
                            // id_paciente: this.dados.paciente.id_pessoa,
                            id_procedimento: procedimento ? procedimento.id_procedimento : null,
                        }
                    }
                ]};

                this.axios.post('/aql', query)
                    .then(res => { 
                        if ( res.data.stats.status == 200 ) {
                            // this.pacienteMedicoStats = res.data.stats.data.medicos;
                        }
                    });

            } 
            
        },

        selecionarMedico (medico) { 
                    
            this.dados.medico = medico;
            
            this.$nextTick(() => {
                this.focusOn('adicionar');
            });

            if ( medico && this.data ) { 

                this.espontaneaHora = null;

                let query = { q: [ 
                    { 
                        name: 'medicos.horarios',
                        id: 'horarios',
                        parms: { 
                            id_medico: medico.id_pessoa,
                            id_procedimento: this.dados.procedimento.id_procedimento,
                            data: this.data
                        }
                    }
                ]};

                this.axios.post('/aql', query)
                    .then(res => { 
                        if ( res.data.horarios.status == 200 ) {
                            this.faixaHorarios = res.data.horarios.data;
                        }
                    });

            }

        },

        enterNoProcedimento () { 

            if ( !this.dados.procedimento && this.procedimentos.length ) { 
                this.buscarHorarios ();
            }

        },

        enterNoMedico () { 

            if ( !this.dados.procedimento && this.procedimentos.length ) { 
                this.buscarHorarios ();
            } else if ( this.dados.procedimento ) { 
                this.adicionarProcedimento () 
            }

        },

        focusOn (item) { 

            /*
            if ( item == 'info_medico' && !this.dados.procedimento && this.procedimentos.length ) { 
                this.buscarHorarios ();
                return;
            }

            if ( item == 'adicionar' ) { 
                if ( this.dados.procedimento ) { 
                    this.adicionarProcedimento () 
                } else { 
                    this.buscarHorarios ();
                }
                return;
            }
            */

            if ( this.$refs[item] && this.$refs[item].$refs.input ) { 
                this.$refs[item].$refs.input.focus ();
            } 

        },

        voltar () { 

            if ( this.remarcacao ) { 
                this.$router.go(-1);
                return;
            }

            if ( this.horario_selecionado ) { 
                this.horario_selecionado = null;
            }

            if ( this.hora_selecionada ) { 
                this.hora_selecionada = null;
            }

            this.dadosRemarcacao = null;

            if ( this.horarios ) { 

                if ( this.$refs.instrucoes )
                    this.$refs.instrucoes.reset();

                this.horarios = null;
                
                let query = { q: [{ name: 'agendas.liberar_reservas', id: 'liberar' }]};
                this.axios.post('/aql', query);

                this.procedimentos = [];

                /*
                this.procedimentos.forEach(element => {
                    element.base = null;
                    element.data = null; 
                    element.hora = null;
                    element.ordem_chegada = null;
                });
                */
                
                return;
            }

            this.reiniciar ();

        },

        grupo_hora_selecione () { 

            return _.groupBy(this.hora_selecionada, 'hora');

        },

        marcar_dias_todos () {

            if ( !this.diasTodos )
                this.diasDaSemana = [true, true, true, true, true, true, true];
            else
                this.diasDaSemana = [false, false, false, false, false, false, false];

        },

        marcar_medicos_todos () { 

            let base = !this.medicosTodos;
            let tmp = [];

            _.forEach(this.medicos, function (item, index) { 
                tmp[index] = base;
            });

            this.medicosSelecionados = tmp;

        },

        selecionar_hora (hora) { 

            this.hora_selecionada = hora;
            $('[data-toggle="tooltip"]').tooltip('hide');
            $('#minutoModal').modal('show');
            
        },

        selecionar_horario (horario, unidade) {  

            this.instrucoes_ciente = [];
            this.horario_selecionado = horario;
            this.dados.reserva = null;

            console.log('dados', this.dados);

            $('[data-toggle="tooltip"]').tooltip('hide');

            let query = { q: [ 
                {
                    name: 'agendas.reservar', 
                    id: 'reservar', 
                    parms: { 
                        data: horario.data,
                        hora: horario.hora, 
                        medico: horario.medico,
                        ordem_chegada: horario.ordem_chegada ? true : false, 
                        paciente: this.dados.paciente,
                        procedimento: this.procedimentos[horario.index].procedimento,
                        remarcacao: this.remarcacao ? this.remarcacao : ( this.dadosRemarcacao ? this.dadosRemarcacao.id_marcacao : null ),
                        id_unidade_operacao: horario.id_unidade_operacao,
                        id_plano: this.procedimentos[horario.index].plano ? this.procedimentos[horario.index].plano.id_plano : null,
                        portal: true, 
                    }
                }
            ]};

            this.axios.post('/aql', query) 
                .then(res => { 
                    if ( res.data.reservar.status == 200 ) { 

                        this.procedimentos[horario.index].index = horario.index;
                        this.procedimentos[horario.index].base = horario.base;
                        this.procedimentos[horario.index].data = horario.data;
                        this.procedimentos[horario.index].hora = horario.hora;
                        this.procedimentos[horario.index].medico = horario.medico;
                        this.procedimentos[horario.index].medico.instrucao = res.data.reservar.data.st_instrucao_agenda_online;
                        this.procedimentos[horario.index].ordem_chegada = horario.ordem_chegada ? true : false;
                        this.procedimentos[horario.index].extra = false;
                        this.procedimentos[horario.index].id_unidade_operacao = horario.id_unidade_operacao;
                        this.procedimentos[horario.index].unidade = unidade;
                        this.procedimentos[horario.index].repetir = false;
                        this.procedimentos[horario.index].repeticao = { base: horario.data, hora: horario.hora };
                        this.procedimentos[horario.index].doc_pre_atends = res.data.reservar.data.doc_pre_atends;
                        
                        this.dados.doc_pre_atends = res.data.reservar.data.doc_pre_atends;
                        this.dados.reserva = res.data.reservar.data;

                        this.$forceUpdate ();

                        $('#minutoModal').modal('hide');

                        let falta = _.findIndex (this.procedimentos, function (item) { 
                            return !item.hora;
                        });

                        if ( falta < 0 ) { 

                            let instr = this.$refs.instrucoes.instrucoes ? this.$refs.instrucoes.instrucoes : [];
                            let instr_pre = this.$refs.instrucoes.lista_pre ? this.$refs.instrucoes.lista_pre : [];
                           
                            this.instrucoes_ciente = [...instr, ...instr_pre];

                            if ( this.instrucoes_ciente.length ) { 
                                $('#cienteInstrucoesModal').modal('show');
                            } else { 
                                $('#cadastroModal').modal('show');
                            }
                        }

                    }
                });
            
        },

        ciente_instrucoes() { 
            $('#cienteInstrucoesModal').modal('hide');
            $('#cadastroModal').modal('show');
        },

        adicao_direta () { 

            // Validação da restrição
            //

            this.adicionarProcedimento ();

            this.procedimentos[0].data = this.data;
            this.procedimentos[0].hora = this.hora ? this.hora : this.espontaneaHora;
            this.procedimentos[0].medico = this.dados.medico;
            this.procedimentos[0].adicao_direta = true;
            this.procedimentos[0].ordem_chegada = false;

            this.marcar ();

        },

        grupo_hora (horarios) { 

            let self = this;

            let filtered = _.filter(horarios, function (i) { 
                return parseInt(i.base, 10) >= self.faixaInicio && 
                        parseInt(i.base, 10) <= self.faixaFim &&
                        i.status == 'livre'; 
            })

            let not_sorted = _.groupBy(filtered, function (i) { 
                    return parseInt(i.base, 10);
                });

            let sorted = Object.keys(not_sorted)
                .sort()
                .reduce(function (acc, key) { 
                    acc[key] = not_sorted[key];
                    return acc;
                }, {});

            return sorted;

        },

        lista_hora (hora) { 

            if ( hora.length && hora[0].ordem_chegada ) { 
                return 'Ocupação: ' + hora[0].marcados + ' / ' + hora[0].vagas;
            }

            return hora.reduce ((total, item) => { 
                return total.indexOf(item.hora) >= 0 ? total : total + item.hora + '<br>';
            }, "");

        },

        check_marcado (hora) {
            return this.procedimentos[hora[0].index].base == hora[0].base && 
                    this.procedimentos[hora[0].index].data == hora[0].data;
        },

        grupo_hora_chaves (horarios) { 

            let not_sorted = _.groupBy(horarios, function (i) { 
                    return parseInt(i.base, 10);
                });

            let sorted = Object.keys(not_sorted)
                .sort()
                .reduce(function (acc, key) { 
                    acc[key] = not_sorted[key];
                    return acc;
                }, {});

             return sorted;

        },
        
        reiniciar () { 

            this.fluxo = 1;
            this.validarCadTemp = false;
            this.procedimentos = [];
            this.dados.plano = { id_plano: "", id_operadora: "" };
            this.dados.especialidade = ""; 
            this.dados.tipoProcedimento = ""; 
            this.dados.medico = ""; 
            this.dados.procedimento = ""; 
            this.dados.unidade_operacao = ""; 
            this.dados.consultas = [] ;
            this.hora_selecionada = null;
            this.horarios = null;
            this.pacienteMedicoStats = null;
            this.pacienteProcStats = null;
            this.fl_tele_atendimento = false; 
            this.dadosRemarcacao = null;

            if ( this.config_apenas_cons ) { 
                this.dados.tipoProcedimento = "C"; 
            } else if ( this.config_apenas_proced ) { 
                this.dados.tipoProcedimento = "P"; 
            }
            
            //this.historicoMarcacoes = null;
            this.cadastro_temporario = {
                id_cadastro_temporario: this.$store.state.user.id_cadastro_temporario, 
            };

            this.espontaneaHora = "";
            this.st_observacoes = "";
            this.subespecialidades = null;

            if ( this.tmaInterval ) { 
                clearInterval ( this.tmaInterval );
                this.tmaInterval = null;
            }

            this.load_mine();
            this.iniciar_paciente();

        },

        adicionarProcedimento () { 

            if ( !this.podeMarcar && !this.data ) { 
                alert ('Restrição para marcação. Reveja os itens selecionados.');
                return;
            }

            if ( !this.id_plano_padrao ) { 

                if ( this.dados.plano && this.dados.plano.id_plano ) { 
                    
                    let teste = this.lista_planos.find(item => item.id_operadora == this.dados.plano.id_operadora && item.id_plano == this.dados.plano.id_plano);

                    if ( !teste ) { 
                        alert ('Plano não identificado.');
                        return;
                    }

                    this.dados.plano = _.cloneDeep(teste);

                } else { 

                    alert ('Operadora/Plano não identificado.');
                    return;
                    
                }

            }

            let procedimento = _.cloneDeep (this.dados);

            procedimento.selected = true;
            procedimento.subespecialidades = this.subespecialidades
                ? this.subespecialidades.filter(sub => sub.selecionado)
                    .map(sub => sub.tag)
                : null;
            
            if ( this.data ) { 
                this.procedimentos = [];
            }
            
            this.procedimentos.push(procedimento);

            if ( !this.data ) { 

                this.dados.medico = null;
                this.dados.procedimento = null;

                if ( this.dados.tipoProcedimento == 'C' && !this.config_apenas_cons ) { 
                    this.dados.tipoProcedimento = ""; 
                }

                this.focusOn('info_procedimento');

            }

        },

        removerProcedimento (index) { 

            this.procedimentos.splice(index, 1);

        },

        buscarHorarios (buscarMais = false) { 

            if ( this.agendar_para == 'P' ) { 
                if ( !this.dados.dt_nascimento ) { 
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "Informe a data de nascimento.",
                        life: 3000
                    });
                    return;
                }

                if ( !this.dados.ch_sexo ) { 
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "Informe o sexo.",
                        life: 3000
                    });
                    return;
                }

                this.cadastro_temporario.dt_nascimento = this.dados.dt_nascimento;
                this.cadastro_temporario.ch_sexo = this.dados.ch_sexo;
            }

            let buscaAdicional = buscarMais && !!this.buscadoAte;

            //if ( !this.procedimentos.length )
            if ( !buscaAdicional ) { 
                this.procedimentos = [];
                this.lista_medicos_agenda = [];
            }
            
            this.$nextTick(() => {

                if ( !buscaAdicional ) { 
                    this.$forceUpdate ();
                    this.adicionarProcedimento ();
                }

                if ( !this.procedimentos.length )
                    return;

                if ( !this.procedimentos[0].procedimento ) { 
                    this.dadosRemarcacao = null;

                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "Selecione o procedimento.",
                        life: 3000
                    });

                    return;
                }

                this.buscando = true;

                if ( !this.podeMarcar ) { 
                    this.dadosRemarcacao = null;
                    this.buscando = false;
                    alert ('Restrição para marcação. Reveja os itens selecionados.');
                    return;
                }

                if ( this.data ) { 
                    this.buscando = false;
                    this.dadosRemarcacao = null;
                    return;
                }

                const portalDiasAnteced = this.configs.find(config => config.st_slug == 'portal-dias-anteced');

                let inicio = buscarMais ? 
                    moment(this.buscadoAte).add(1, 'd').format('YYYY-MM-DD') :
                    moment().add(( portalDiasAnteced ? portalDiasAnteced.st_valor : 0 ),'d').format('YYYY-MM-DD');

                let tempo_padrao = ( this.listaMedicos && this.listaMedicos.length > 10 ) ? 15 : 30;

                this.buscadoAte = buscarMais ? 
                    moment(this.buscadoAte).add(tempo_padrao, 'd').format('YYYY-MM-DD') :
                    moment(inicio).add(tempo_padrao, 'd').format('YYYY-MM-DD');

                let query = { q: [] };

                this.procedimentos.forEach((item, index) => { 
                    query.q.push({ 
                        name: 'agendas.index',
                        id: 'horarios.' + index,
                        parms: { 
                            inicio: inicio, 
                            fim: this.buscadoAte,
                            medico: ( item.medico ? item.medico.id_pessoa : "" ),
                            procedimento: ( item.procedimento ? item.procedimento.id_procedimento : "" ),
                            plano: ( item.plano ? item.plano.id_plano : "" ),
                            livres: true, 
                            group: 'none',
                            index: index,
                            para_marcar: true,  
                            unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                            subespecialidades: item.subespecialidades,
                            id_especialidade: ( item.procedimento ? item.procedimento.id_especialidade : null ),
                            outra_pessoa: ( this.agendar_para == 'P' ),
                            dt_nascimento: this.agendar_para == 'P' ? this.dados.dt_nascimento : null, 
                            ch_sexo: this.agendar_para == 'P' ? this.dados.ch_sexo : null, 
                            id_marcacao_remarcacao: this.dadosRemarcacao 
                                ? this.dadosRemarcacao.id_marcacao 
                                : null,
                            remarcacao: this.dadosRemarcacao ? true : false,
                            id_solicitacao_autorizacao: this.dadosRemarcacao ? this.dadosRemarcacao.id_solicitacao_autorizacao : null, 
                        }
                    })
                });

                this.axios.post ('/aql?a=agendas.index', query)
                    .then(res => { 
                        if ( res.data['horarios.0'].status >= 400 ) { 

                            this.dadosRemarcacao = null;

                        } else if ( res.data['horarios.0'].status == 201 ) { 

                            this.horarios = [];
                            this.medicosSelecionados = [];
                            this.unidadesSelecionadas = [];
                            this.dadosRemarcacao = null;

                            this.informacao = _.get(res.data['horarios.0'], 'data.aviso');

                            if ( this.informacao ) { 
                                this.voltar();
                                $('#instrucaoModal').modal('show');
                            }

                        } else { 

                            console.log('res', res);

                            this.dt_prazo_revisao = res.data['horarios.0'].data.parms.dt_prazo_revisao;

                            let todos = [];
                            _.forEach (res.data, function (item) {
                                todos = _.concat(todos, item.data.agendas);
                            });

                            if ( buscaAdicional && this.horarios ) { 
                                this.horarios = _.concat(this.horarios, todos);
                            } else { 
                                this.horarios = todos;
                            }
                            
                            let med = [];

                            if ( res && res.data && res.data.medicos ) {
                                this.lista_medicos_agenda = this.lista_medicos_agenda.concat(res.data.medicos);
                            }

                            _.forEach(this.medicos, function () {
                                med.push(true);
                            });

                            this.medicosSelecionados = med;
                            this.medicosTodos = true;

                            let und = [];

                            _.forEach(this.unidades, function () {
                                und.push(true);
                            });

                            this.unidadesSelecionadas = und;
                            this.unidadesTodas = true;

                            this.$nextTick(() => { 
                                this.$refs.instrucoes.buscar_plano(this.dados);
                                this.$refs.instrucoes.buscar_procedimento(this.dados);
                            });

                        }
                    })
                    .finally(() => { 
                        this.buscando = false;
                    });

            });

        },

        marcar() { 

            this.validarCadTemp = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length && $('.invalid').is(':visible') ) { 

                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });
                    
                } else { 

                    if ( this.dados.reserva && this.dados.reserva.doc_reqs && this.dados.reserva.doc_reqs.length ) { 

                        let teste = this.dados.reserva.doc_reqs.find(item => !item.arquivo);

                        if ( teste ) { 
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: "Anexar os documentos solicitados. \n" + teste.st_mensagem,
                                life: 3000
                            });
                            return;
                        }

                    }
                            
                    let dados;

                    if ( this.fluxo == 1 && ( this.dados.paciente && !this.dados.paciente.paciente_unidade ) ) { 

                        this.cadastro_temporario = { 
                            id_cadastro_temporario: this.$store.state.user.id_cadastro_temporario, 
                            st_nome: this.dados.paciente.st_nome,
                            ch_sexo: this.dados.paciente.cadastro.ch_sexo,
                            st_email: this.dados.paciente.cadastro.st_email,
                            dt_nascimento: this.dados.paciente.cadastro.dt_nascimento,
                            st_telefone: this.dados.paciente.cadastro.telefones.telefone,
                            st_celular: this.dados.paciente.cadastro.telefones.celular,
                            st_numero_carteira: this.dados.paciente.st_numero_carteira, 
                            dt_validade_carteira: this.dados.paciente.dt_validade_carteira, 
                        };

                        dados = { 
                            plano: { 
                                id_plano: "", 
                            },
                            id_cadastro_temporario: this.$store.state.user.id_cadastro_temporario, 
                            cadastro_temporario: this.cadastro_temporario,
                            procedimentos: this.procedimentos,
                            st_observacoes: this.st_observacoes, 
                            doc_pre_atends: this.dados.doc_pre_atends 
                        };

                    } else if ( this.agendar_para == 'P' ) {  

                        dados = { 
                            id_cadastro_temporario: this.$store.state.user.id_cadastro_temporario, 
                            plano: this.dados.plano 
                                ? this.dados.plano 
                                : { id_plano: "" },
                            cadastro_temporario: this.cadastro_temporario,
                            procedimentos: this.procedimentos,
                            st_observacoes: this.st_observacoes, 
                            doc_pre_atends: this.dados.doc_pre_atends 
                        };

                    } else { 

                        dados = { 
                                paciente: this.dados.paciente,
                                procedimentos: this.procedimentos,
                                st_observacoes: this.st_observacoes, 
                                plano: this.dados.paciente.paciente_unidade.plano, 
                                doc_pre_atends: this.dados.doc_pre_atends 
                            };

                    }

                    dados.origem = 'portal';

                    if ( this.dados.reserva && this.dados.reserva.id_reserva_horario ) { 
                        dados.id_reserva_horario = this.dados.reserva.id_reserva_horario;
                    }

                    let query = { q: [
                        { 
                            name: 'agendas.store',
                            id: 'marcar',
                            parms: { 
                                ...dados,
                                inicio: this.tmaInicio,
                                termino: this.tmaFim,
                                remarcacao: this.remarcacao ? this.remarcacao : ( this.dadosRemarcacao ? this.dadosRemarcacao.id_marcacao : null ),
                                outra_pessoa: ( this.agendar_para == 'P' ),
                                fl_tele_atendimento: this.fl_tele_atendimento,
                            }
                        }
                    ]};

                    this.buscando = true;
                    this.$store.commit('loading', true);

                    this.axios.post ('/aql?a=agendas.store', query)
                        .then(res => { 
                            if ( res.data.marcar.status == 200 ) { 

                                if ( process.env.VUE_APP_GTAG ) { 

                                    let action = 'marcar-portal';
                                    let label = this.$store.state.user.id_usuario;

                                    this.$gtag.event(action, {
                                        'event_category': window.redir,
                                        'event_label': label,
                                        'value': 1
                                    });

                                }

                                this.resumo = res.data.marcar.data;

                                if ( this.modalName )
                                    $(this.modalName).modal('hide');


                                $('#cadastroModal').modal('hide');

                                this.aviso_final = setTimeout(() => {
                                    this.aviso_final = null;
                                    $(".modal").modal('hide');

                                    if ( this.remarcacao ) { 
                                        this.$router.go(-1);
                                        return;
                                    }
                                }, ( this.resumo.msg_final ? 25000 : 2500 ));

                                this.reiniciar ();

                                this.load_mine();      
                                
                                this.$emit('refresh');

                            }
                        })
                        .finally(() => { 
                            this.buscando = false;
                            this.$store.commit('loading', false);
                        });

                }

            });

        },

        // Funções de Formatação de Data/Hora.

        getFormatDate (date, format) { 
            return moment(date, 'YYYY-MM-DD').format(format);
        },

        getHumanDay (date) {
            return moment(date, 'YYYY-MM-DD').format('dddd');
        },

        getHumanDate (date) {
            return moment(date, 'YYYY-MM-DD').format('DD') + ' de ' + 
                moment(date, 'YYYY-MM-DD').format('MMMM') + 
                ( moment(date, 'YYYY-MM-DD').format('YYYY') == new Date().getFullYear() ? '' : 
                    ' de ' + moment(date, 'YYYY-MM-DD').format('YYYY') );
        },

        getHumanDuration (date) {  
            let end = moment().startOf('day');
            return moment.duration(moment(date, 'YYYY-MM-DD').diff(end)).humanize(true);
        },

        load_mine() {

            let query = { q: [ 
                { 
                    name: 'marcacoes.stats',
                    id: 'stats',
                    parms: { 
                        fl_paciente: true, 
                        // id_paciente: this.$store.state.user.id_pessoa,
                        portal: true,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.stats.status == 200 ) {
                        this.pacienteProcStats = res.data.stats.data;
                        this.historicoMarcacoes = res.data.stats.data.marcacoes;
                        this.historicoAutorizacao = res.data.stats.data.autorizacao;

                        this.minhas = true;

                        this.$nextTick(() => { 
                            $('[data-toggle="tooltip"]').tooltip();
                            this.$forceUpdate();
                        });
                    }
                });

        },

        teste_plano() { 
            /*
            this.dados.plano = null;

            this.$nextTick(() => { 
                if ( this.id_plano_padrao ) { 
                    this.dados.plano = { id_plano: this.id_plano_padrao };
                } else if ( this.$store.state.user.pessoa.paciente_unidade && this.$store.state.user.pessoa.paciente_unidade.plano ) { 
                    this.selecionarPlano(this.$store.state.user.pessoa.paciente_unidade.plano);
                }
            });
            */
        },

        iniciar_paciente () { 

            let paciente = this.$store.state.user.st_tipo == 'X' ? null : this.$store.state.user.pessoa;

            if ( paciente && !paciente.cadastro ) { 
                paciente.cadastro = { telefones: {} };
            }

            this.dados.paciente = paciente;

            if ( this.config_apenas_cons ) { 
                this.dados.tipoProcedimento = 'C';
            } else if ( this.config_apenas_proced ) { 
                this.dados.tipoProcedimento = 'P';
            }

            if ( this.id_plano_padrao ) { 
                this.dados.plano = { id_plano: this.id_plano_padrao };
            } else { 
                if ( this.$store.state.user.pessoa.paciente_unidade && this.$store.state.user.pessoa.paciente_unidade.plano ) { 
                    this.dados.plano = this.$store.state.user.pessoa.paciente_unidade.plano;
                    this.selecionarPlano(this.dados.plano);
                }
            }

        }
        
    },

    mounted () { 

        if ( process.env.VUE_APP_GTAG ) { 

            let action = 'acesso-portal';
            let label = this.$store.state.user.id_usuario;

            this.$gtag.event(action, {
                'event_category': window.redir,
                'event_label': label,
                'value': 1
            });

        }

        this.$util.loadItem(this, { 
            service: 'configuracoes',
            func: 'index',
            parms: { 
                where: { 
                    id_perfil: 16
                },
            }
        })
        .then(res => { 
            this.configs = res;
        });

        this.$util.loadItem(this, { 
            service: 'configuracoes',
            func: 'index',
            parms: { 
                where: { 
                    st_slug: [
                        'portal-plano-padrao', 
                        'portal-block-alterar-plano', 
                        'portal-apenas-consulta', 
                        'portal-apenas-procedimento', 
                        'portal-unidade-obrigatoria',
                        'marcacao-block-sel-medico'
                    ]
                },
            }
        })
        .then(res => { 
            if ( res && res.length > 0 ) { 

                let config_pp = res.find(item => item.st_slug == 'portal-plano-padrao');
                let config_ap = res.find(item => item.st_slug == 'portal-block-alterar-plano');
                this.config_apenas_cons = res.find(item => item.st_slug == 'portal-apenas-consulta' && item.st_valor == '1') ? true : false;
                this.config_apenas_proced = res.find(item => item.st_slug == 'portal-apenas-procedimento' && item.st_valor == '1') ? true : false;
                this.config_portal_unidade_obrig = res.find(item => item.st_slug == 'portal-unidade-obrigatoria' && item.st_valor == '1') ? true : false;
                this.config_block_sel_medico = res.find(item => item.st_slug == 'marcacao-block-sel-medico' && item.st_valor == '1') ? true : false;

                if ( config_pp ) { 
                    this.id_plano_padrao = parseInt(config_pp.st_valor);
                }

                if ( config_ap ) { 
                    this.block_alterar_plano = parseInt(config_ap.st_valor) ? true : false;
                }

            }

            this.load_mine();
            this.iniciar_paciente();
        });


        if ( this.$store.state.user.st_tipo == 'X' ) { 
            this.agendar_para = 'P';
            this.dados.paciente = null;
            this.dados.dt_nascimento = "";
            this.dados.ch_sexo = "";

            $('#infoPacienteOutroModal').modal('show');
        }

        /*

        let paciente = this.$store.state.user.pessoa;

        if ( !paciente.cadastro ) { 
            paciente.cadastro = { telefones: {} };
        }

        this.dados.paciente = paciente;

        if ( this.$store.state.user.pessoa.paciente_unidade && this.$store.state.user.pessoa.paciente_unidade.plano ) { 
            this.dados.plano = this.$store.state.user.pessoa.paciente_unidade.plano;
            this.selecionarPlano(this.dados.plano);
        }

        */

        this.loadOptions ('marcacoes.stats', 'marcacoesStats')
            .then(() => { 
                //console.log('ESTATÍSTICAS...');
                //console.log(res);
            });

        this.loadOptions ('planos.index', 'planos.index', { atendimento: true, portal: true })
            .then(res => { 
                this.lista_planos = res;

                if ( this.apenas_particular ) { 
                    let pp = this.lista_planos.find((item) => { 
                        return item.id_plano == 1;
                    });

                    if ( pp ) { 
                        this.selecionarPlano(pp);
                    }
                }
            });

        this.loadOptions ('operadoras.index', 'operadoras.index', { agenda_online: true })
            .then(res => { 
                this.lista_operadoras = res;
            });

        this.loadOptions ('especialidades.index', 'especialidades', { ativadas: true, portal: true })
            .then(res => { 
                this.especialidades = res;
            });    

        if ( this.remarcacao ) { 

            this.startFluxo(2);

            let query = { q: [ 
                { 
                    name: 'marcacoes.show',
                    id: 'marcacao', 
                    parms: { 
                        id: this.remarcacao,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.marcacao.status == 200 ) { 
                        this.dadosRemarcacao = res.data.marcacao.data;

                        this.dados.paciente = res.data.marcacao.data.paciente;
                        this.selecionarPaciente();

                        this.dados.plano = res.data.marcacao.data.plano;
                        this.selecionarPlano(this.dados.plano);

                        this.dados.procedimento = res.data.marcacao.data.procedimento;
                        this.selecionarProcedimento(this.dados.procedimento);

                        this.buscarHorarios ();
                    }
                });

        }

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>

<style scoped>
.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.atalho { 
    opacity: 0.95;
}

.atalho:hover {
	opacity: 1;
}

.atalho:hover i { 
    -webkit-transition: opacity 0.2s ease-in;
    -moz-transition: opacity 0.2s ease-in;
    -o-transition: opacity 0.2s ease-in;
    transition: opacity 0.2s ease-in;
    opacity: 0;
}

.atalho:hover div {
	-webkit-transform: translate3d(0,-30px,0);
	transform: translate3d(0,-30px,0);
}

.atalho:hover div {
	-webkit-transition-delay: 0.05s;
	transition-delay: 0.05s;
	-webkit-transition-duration: 0.35s;
	transition-duration: 0.35s;
}

.atalho i,
.atalho div {
	-webkit-transition: -webkit-transform 0.35s;
	transition: transform 0.35s;
}
</style>